import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { firstValueFrom } from 'rxjs';

import {
	openCreateNewSubscriptionModal,
	openCreateNewSubscriptionModalFromDatablock,
	selectSubscription,
	SubscriptionSelector,
} from './store';

@Injectable()
export class NgProjectSubscription {
	public constructor(
		private readonly store: Store,
		private readonly selector: SubscriptionSelector
	) {}

	public openCreateNewProjectSubscriptionModal(): void {
		this.store.dispatch(openCreateNewSubscriptionModal());
	}

	public openCreateNewProjectSubscriptionFromDatablock(
		datablockId: number,
		datablockLabel: string
	): void {
		this.store.dispatch(
			openCreateNewSubscriptionModalFromDatablock({
				datablockId,
				datablockLabel,
			})
		);
	}

	public async getInViewSubscriptionId(): Promise<number> {
		return await firstValueFrom(this.selector.getSubscriptionId$());
	}

	public selectSubscription(subscriptionId: number): void {
		this.store.dispatch(
			selectSubscription({
				subscriptionId,
			})
		);
	}
}
